export enum Routes {
  home = '/',

  page403 = '/403',
  page404 = '/404',
  page500 = '/500',

  playground = '/playground',

  v2_projectList = '/v2/projects',
  v2_newProject = '/v2/projects/new',
  v2_projectDetail = '/v2/projects/:projectId',
}

export const getV2HomeUrl = () => {
  return window.location.origin + Routes.v2_projectList;
};
